import React from 'react';
import { Link } from 'react-router-dom';
import { portfolioData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1E293B] text-white py-12 px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-2xl font-bold">{portfolioData.name}</div>
          
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/impressum" 
              className="text-gray-400 hover:text-white transition-colors"
            >
              Impressum
            </Link>
            <Link 
              to="/datenschutz" 
              className="text-gray-400 hover:text-white transition-colors"
            >
              Datenschutz
            </Link>
          </div>
          
          <div className="text-gray-400 text-sm">
            © {currentYear} Alle Rechte vorbehalten
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;